import { CaseDetail } from "../../models/CaseDetail/caseDetail.model";
import { UserRoleEnum } from "../../enums/userRole.enum";

export function buildCaseChatUnreadCountsFromCases(
  cases: CaseDetail[]
): Record<number, number> {
  const m: Record<number, number> = {};
  cases.forEach((c) => {
    if (c.id != null && typeof c.unreadChatCount === "number") {
      m[c.id] = c.unreadChatCount;
    }
  });
  return m;
}

export function getDisplayedCaseChatUnread(
  caseDetailId: number | undefined,
  caseDetailUnread: number | undefined,
  storeCounts: Record<number, number>,
  /** When this case’s chat drawer is open, treat as read in the listing. */
  openChatCaseDetailId?: number | null
): number {
  if (caseDetailId == null) return 0;
  if (
    openChatCaseDetailId != null &&
    caseDetailId === openChatCaseDetailId
  ) {
    return 0;
  }
  if (Object.prototype.hasOwnProperty.call(storeCounts, caseDetailId)) {
    return storeCounts[caseDetailId];
  }
  return caseDetailUnread ?? 0;
}

export function isOwnCaseChatSocketSender(
  userRole: UserRoleEnum | undefined,
  user: { id?: number } | null | undefined,
  sender: { type?: string; id?: number } | undefined
): boolean {
  if (!user?.id || !sender?.type || sender.id == null || userRole == null)
    return false;
  const t = String(sender.type).toLowerCase();
  if (t === "admin" && userRole === UserRoleEnum.ADMIN && user.id === sender.id)
    return true;
  if (t === "doctor" && userRole === UserRoleEnum.DOCTOR && user.id === sender.id)
    return true;
  if (
    t === "scan_center" &&
    userRole === UserRoleEnum.SCAN_CENTER &&
    user.id === sender.id
  )
    return true;
  return false;
}
